import { memo, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { useUser } from '../../../components/form/user-form/use-user';
import { validateUser } from '../../../models/validate-user';
import { UserForm } from '../../../components/form/user-form/user-form';
import { emptyUser } from '../../../models/empty-user';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IAddAnyMemberModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  handleAddMember: (data: any) => void;
  selectMember: any;
  managedByList: any;
}

const AddAnyMemberModal = ({
  open,
  handleClose,
  handleAddMember,
  selectMember,
  managedByList,
}: IAddAnyMemberModalProps) => {
  const { updateUser, user, resetState } = useUser({ ...emptyUser });
  const { fieldErrors, hasErrors } = validateUser(user, ['password']);
  const intl = useIntl();

  useEffect(() => {
    handleClose();
    resetState();
  }, [selectMember.loading]);

  const onClose = () => {
    handleClose();
    resetState();
  };

  const onClickActionButton = () => {
    if (!hasErrors) {
      const memberData = {
        name: user.profile.name,
        email: user.email,
        contactNumber: user.profile.contactNumber,
        customerId: user.parentId.id,
      };
      handleAddMember(memberData);
    }
  };

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'add_member',
      })}
      modalDescription={intl.formatMessage({
        id: 'make_member_manage_meetings',
      })}
      id="add-member-modal"
      open={open}
      isSingleButton
      handleClose={onClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'add_member',
      })}
      actionButtonDisabled={hasErrors}
    >
      <UserForm
        user={user}
        updateUser={updateUser}
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          contactNumber: {
            error: fieldErrors.contactNumber,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
          status: {
            error: fieldErrors.status,
            required: true,
          },
          parentId: {
            error: fieldErrors.parentId,
            required: true,
            managedByList: managedByList,
          },
        }}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(AddAnyMemberModal));
